import { gql } from '@apollo/client';
import { Schema } from './schema';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { PREMIUM_FRAGMENT } from './query';

export type QueryVariables = {
  input: {
    corporatePension?: string;
    corporatePensionImage?: FileType | File | null;
    disabilityMutualAid?: string;
    disabilityMutualAidImage?: FileType | File | null;
    personalPension?: string;
    personalPensionImage?: FileType | File | null;
    smallAndMediumSizedEnterprises?: string;
    smallAndMediumSizedEnterprisesImage?: FileType | File | null;
  };
};

export const convertFormDataToQueryVariables = (data: Schema): QueryVariables => {
  return {
    input: {
      corporatePension: data.corporatePension || '0',
      corporatePensionImage: data.corporatePensionImage,
      disabilityMutualAid: data.disabilityMutualAid || '0',
      disabilityMutualAidImage: data.disabilityMutualAidImage,
      personalPension: data.personalPension || '0',
      personalPensionImage: data.personalPensionImage,
      smallAndMediumSizedEnterprises: data.smallAndMediumSizedEnterprises || '0',
      smallAndMediumSizedEnterprisesImage: data.smallAndMediumSizedEnterprisesImage
    }
  };
};

export const ANSWER_PREMIUM = gql`
  mutation AnswerPremium($input: AnswerPremiumInput!) {
    answerPremium(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        ...Premium
      }
    }
  }
  ${PREMIUM_FRAGMENT}
`;
